import React from 'react';
import { Title } from '../../elements/title/title';

import css from './entrance-prices-table.module.scss';

export const EntrancePricesTable = () => {
    return (
        <>
            <Title as="h2" text="entrance prices" />
            <table className={css.root}>
                <tbody>
                    <tr>
                        <td>standard entry</td>
                        <td>€ 28 (including first drink)</td>
                    </tr>
                    <tr>
                        <td>monday till thursday</td>
                        <td>entry after midnight €12,50</td>
                    </tr>
                    <tr>
                        <td>26 or younger</td>
                        <td>
                            € 19,50 (including first drink)
                            <br />€ 14 monday & thursday (including first
                            drink)
                        </td>
                    </tr>
                    <tr>
                        <td>10-visit-card</td>
                        <td>€ 250 (including first drink on every visit)</td>
                    </tr>
                    <tr>
                        <td>re-entry card (same day)</td>
                        <td>€ 5</td>
                    </tr>
                    <tr>
                        <td>extra towel</td>
                        <td>€ 1</td>
                    </tr>
                    <tr>
                        <td colSpan={2}>
                            we also sell slippers (€ 5,50) and offer douche
                            facilities.
                        </td>
                    </tr>
                    <tr>
                        <td colSpan={2}>
                            douche hoses (spoelslangen) available at the bar (€
                            3)
                        </td>
                    </tr>
                </tbody>
            </table>
        </>
    );
};
